import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import styles from "./DefaultLayout.module.css";

const DefaultLayout = ({
  children,
  fullLogo = false,
  showActivePromo = false,
  persistentHeaderTitle = "",
  showSubscribeLink = false,
}) => (
  <>
    <Header
      persistentHeaderTitle={persistentHeaderTitle}
      fullLogo={fullLogo}
      showActivePromo={showActivePromo}
      showSubscribeLink={showSubscribeLink}
    />
    <main className={styles.main}>{children}</main>
    <Footer />
  </>
);

export default DefaultLayout;
